import { useMediaQuery } from "@mui/system";

export const useFeatureMedia = () => {
  const isMediumScreen = useMediaQuery(
    "(min-width:1100px) and (max-width:1319.98px) "
  );
  const isLargeScreen = useMediaQuery("(min-width:1320px)");

  return { isMediumScreen, isLargeScreen };
};
